import { allItemsSelected, anyItemSelected } from '@openx/components-table/SelectableTable/selectCheckers';
import type { AudienceSegmentEntry } from '@openx/types/gqlTypes';
import { SelectOperation } from '@openx/types/selectableTable';
import { applySelectionChange } from '@openx/utils/lib/applySelectionChange';
import isEqual from 'lodash/isEqual';

export type GetNextAudienceSelectionOnToggleAllArgs = {
  allItems: AudienceSegmentEntry[];
  visibleItems: AudienceSegmentEntry[];
  selectedItems: AudienceSegmentEntry[];
};

export const getNextAudienceSelectionOnToggleAll = ({
  allItems,
  visibleItems,
  selectedItems,
}: GetNextAudienceSelectionOnToggleAllArgs): AudienceSegmentEntry[] => {
  const hasVisibleSelection = anyItemSelected(visibleItems, selectedItems);

  if (hasVisibleSelection) {
    if (allItemsSelected(allItems, selectedItems)) {
      return [];
    }

    return applySelectionChange({
      changeItems: visibleItems,
      itemsComparer: isEqual,
      operation: SelectOperation.UNSELECT,
      previouslySelectedItems: selectedItems,
    });
  }

  return applySelectionChange({
    changeItems: visibleItems,
    itemsComparer: isEqual,
    operation: SelectOperation.SELECT,
    previouslySelectedItems: [],
  });
};
